export enum BulkDataProcessingRequestEnum {
	TimeSurveyExport = 0,
	ExpenseSurveyExport = 1,
	ProjectSurveyExport = 2,
	EmployeeAllocation = 3,
    AdminActivityExport = 4,
    CreditReport = 5,
    DocumentExport = 6,
    CompletedTimeSurveyExport = 7,
    CompletedExpenseSurveyExport = 8
};

export enum BulkDataProcessingDetailsStatusEnum
{
    Uploaded = 1,
    Processing = 2,
    ValidationError = 3,
    SystemException = 4,
    Completed = 5,
    NoDataToProcess = 6
};